import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

function StructuralExterior() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1535732759880-bbd5c7265e3f?fm=webp&q=70&auto=format&fit=max&w=1920)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Structural & <span className="text-gold">Exterior Works</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Comprehensive structural and exterior construction services
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              A building's structural integrity and exterior envelope are fundamental to its performance and longevity. Williams Diversified delivers comprehensive structural and exterior construction services that meet the highest engineering standards.
            </p>
            <p>
              From foundations to framing, we ensure every structural element is built to withstand the test of time. Our structural and exterior work combines engineering precision with construction expertise, creating buildings that are both solid and enduring.
            </p>
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Our Capabilities</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Foundation work and concrete slabs</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Structural steel erection and welding</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Structural framing and reinforcement</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Building envelope systems</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Exterior cladding and facades</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Masonry, stonework, and decorative concrete</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Structural repairs and reinforcement</span></li>
            </ul>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Build on a <span className="text-gold">Solid Foundation</span></h3>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default StructuralExterior;